import React from "react";
import EditIcon from "../../../../assets/svgs/Edit";

const Payslips = () => {
  return (
    <div className="rounded-lg shadow-xl py-5 mb-10 text-sm sm:text-base">
      <div className="flex justify-between py-4 px-5 md:px-9 border-b text-base sm:text-lg">
        <p className="text-lg font-semibold">Payslips</p>
        <button className="space-x-1 w-9 h-9 p-1 text-white flex items-center justify-center rounded-full bg-gradient-to-tr from-pink-500 to-pink-600 shadow-lg">
          <EditIcon />
        </button>
      </div>

      <div className="px-4 py-5 md:px-9 space-y-2">
        <div className="flex justify-between">
          <p>Basic</p>
          <p className="sm:w-24 text-left">Rs 40,000</p>
        </div>
        <div className="flex justify-between">
          <p>Medical Allowance</p>
          <p className="sm:w-24 text-left">Rs 5,000</p>
        </div>
        <div className="flex justify-between">
          <p>Special Allowance</p>
          <p className="sm:w-24 text-left">Rs 2,000</p>
        </div>
        <div className="flex justify-between">
          <p>Income Tax</p>
          <p className="sm:w-24 text-left">(Rs 200)</p>
        </div>
        <div className="flex justify-between">
          <p>Salary Deduction</p>
          <p className="sm:w-24 text-left">Rs (800)</p>
        </div>
      </div>
      <div className="px-4 py-5 md:px-9 border-t flex font-medium justify-between">
        <p>Total</p>
        <p className="sm:w-24 text-left">Rs 46.000</p>
      </div>
    </div>
  );
};

export default Payslips;
